import React, { useState, useEffect, Fragment } from 'react'
import { Card, Row, Col, Badge, Button, Table, Modal } from 'react-bootstrap'
import Cookies from 'js-cookie'
import axios from 'axios'
import { useDispatch } from 'react-redux'
import config from '../../config'
import CONSTANTS from '../../constants/constants'
import { useLocation } from 'react-router-dom'
import SelectedOrderModal from './SelectedOrderModal'
import Pagination from '../../components/Nav/Pagination'
import { getRounds } from '../../services/config-services'
import Swal from 'sweetalert2'
import Colors from '../../constants/Colors'
import UploadCsvModal from './UploadCsvModal'

const PAID_USERPRIZES = CONSTANTS.paidUserPrizes

function useQuery() {
  return new URLSearchParams(useLocation().search)
}
const UserPrizes = () => {
  const query = useQuery()
  const [currentPage, setCurrentPage] = useState(1)
  const [status, setStatus] = useState('all')
  const [prizes, setPrizes] = useState([])
  const [userId, setUserId] = useState('')
  const [selectedOrder, setSelectedOrder] = useState({})
  const [roundDate, setRoundDate] = useState()
  const [rounds, setRounds] = useState([])
  const [showModalPrizes, setShowModalPrizes] = useState(false)
  const [showModalOrder, setShowModalOrder] = useState(false)
  const [detailPrizes, setDetailPrizes] = useState([])
  const [user, setUser] = useState([])
  const [isOpenModal, setIsOpenModal] = useState(false)
  const dispatch = useDispatch()

  const fetchAwards = async (page = currentPage, _status = status) => {
    try {
      dispatch({ type: 'loading_show' })
      if (!query.roundDate) {
        query.roundDate = roundDate
      }
      if (!query.userId) {
        query.userId = userId
      }
      if (page) {
        query.page = page
      }
      if (_status !== 'all') {
        query.autoTransferStatus = _status
      } else {
        query.autoTransferStatus = 'UNKNOWN'
      }
      const response = await axios.get(
        `${config.apiAdminGateway}/api/v2/prizes/rewards?roundDate=${query.roundDate || ''}&status=${
          query.autoTransferStatus.toUpperCase() || 'UNKNOWN'
        }&page=${query.page || 1}${query.userId ? `&userNo=${query.userId}` : ''}`,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get('accessToken')}`,
          },
        },
      )
      if (response.data.status.code === 0) {
        const prizeList = response.data.data
        setPrizes(prizeList)
      } else {
        setPrizes([])
      }
      dispatch({ type: 'loading_hide' })
    } catch (error) {
      setPrizes([])
      dispatch({ type: 'loading_hide' })
    }
  }

  const fetchOrderDetail = async (orderId) => {
    try {
      const response = await fetch(`${config.apiAdminGateway}/api/v3/admin/orders/${orderId}`, {
        headers: {
          Authorization: `Bearer ${Cookies.get('accessToken')}`,
        },
      }).then((res) => res.json())

      if (response.status.code !== 0) throw new Error(response.status.description)

      setSelectedOrder(response.data)
      setShowModalOrder(true)
    } catch (error) {
      console.error(error)
    }
  }

  const fetchAllRounds = async () => {
    const data = await getRounds()
    setRoundDate(data[0].value)
    setRounds(data.map((r) => ({ roundDate: r.value })))
  }

  useEffect(() => {
    if (!roundDate) {
      fetchAllRounds()
    } else {
      fetchAwards()
      setCurrentPage(1)
    }
  }, [roundDate, status])

  const fetchDetail = async (user) => {
    try {
      const response = await axios.get(
        `${config.apiAdminGateway}/api/v2/prizes/rewards/detail?userId=${user.id}&roundDate=${roundDate}`,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get('accessToken')}`,
          },
        },
      )
      if (response.status === 200) {
        setDetailPrizes(response.data.data)
      } else {
        setDetailPrizes([])
      }
    } catch (error) {
      alert('error')
      console.log('error', error)
    }
  }

  const onChangePage = (page) => {
    setCurrentPage(page)
    fetchAwards(page)
  }

  const downloadUserPrizesReport = async () => {
    if (roundDate) {
      try {
        dispatch({ type: 'loading_show' })
        const response = await axios.get(
          `${config.apiAdminGateway}/api/v2/prizes/rewards/download?roundDate=${roundDate}`,
          {
            responseType: 'blob',
            headers: {
              Authorization: `Bearer ${Cookies.get('accessToken')}`,
              'Content-Type': 'text/csv',
            },
          },
        )
        if (response.status === 200) {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url

          const date = new Date()
          const day = String(date.getDate()).padStart(2, '0')
          const month = String(date.getMonth() + 1).padStart(2, '0')
          const year = String((date.getFullYear() + 543) % 100).padStart(2, '0')
          const hour = String(date.getHours()).padStart(2, '0')
          const minute = String(date.getMinutes()).padStart(2, '0')
          const newRoundDate = roundDate.replace(/-/g, '')
          const fileName = `userPrizes_${newRoundDate}_${day}${month}${year}_${hour}${minute}`

          link.setAttribute('download', `${fileName}.csv`)
          document.body.appendChild(link)
          link.click()
          link.parentNode.removeChild(link)
        } else {
          Swal.fire({
            title: `ไม่สามารถดาวน์โหลดรายงานได้`,
            icon: 'info',
            confirmButtonColor: `${Colors.SOFT_BLUE}`,
            confirmButtonText: 'ตกลง',
          })
        }
        dispatch({ type: 'loading_hide' })
      } catch (error) {
        console.error(error)
        dispatch({ type: 'loading_hide' })
      }
    } else {
      Swal.fire({
        title: `กรุณาเลือกงวด`,
        icon: 'info',
        confirmButtonColor: `${Colors.SOFT_BLUE}`,
        confirmButtonText: 'ตกลง',
      })
    }
  }

  const displayDropdownDate = () => {
    return (
      <span className="d-flex">
        {rounds && (
          <div className="w-100">
            <select
              className="form-control"
              value={roundDate}
              style={{ color: '#5d5d5d' }}
              onChange={async (value) => {
                setRoundDate(value.target.value)
              }}
            >
              {rounds.map((round, i) => {
                return (
                  <option key={i} value={round.roundDate}>
                    {round.roundDate}
                  </option>
                )
              })}
            </select>
          </div>
        )}
      </span>
    )
  }

  const displayStatusText = (status) => {
    switch (status) {
      case 'none':
        return 'ยังไม่จ่ายเงิน'
      case 'problem':
        return 'ไม่มีเลขบัญชี'
      case 'success':
        return 'จ่ายเงินแล้ว'
      case 'invalid_bank_account':
        return 'เลขบัญชีผิด'
      default:
        return status
    }
  }

  const displayTablePrize = () => {
    return (
      <Table responsive striped bordered className="verticle-middle">
        <thead>
          <tr>
            <th></th>
            <th>รหัสสมาชิก</th>
            <th>ชื่อ-นามสกุล</th>
            <th>จำนวนรางวัล</th>
            <th>มูลค่า</th>
            <th>รายละเอียด</th>
            <th>เบอร์โทรศัพท์</th>
            <th>สถานะ</th>
          </tr>
        </thead>
        <tbody>
          {prizes &&
            prizes.map((item, i) => {
              return (
                <tr key={i}>
                  <td>
                    {' '}
                    <Badge
                      variant="primary light"
                      style={{ cursor: 'pointer' }}
                      onClick={async () => {
                        setShowModalPrizes(true)
                        await fetchDetail(item.user)
                        setUser({ name: `${item.user.firstName} ${item.user.lastName}`, userId: item.user.userNo })
                      }}
                    >
                      +
                    </Badge>
                  </td>
                  <td>{item.user.userNo}</td>
                  <td>
                    {item.user.firstName} {item.user.lastName}
                  </td>
                  <td>{Number(item?.totalPrize || 0).toLocaleString()} รางวัล</td>
                  <td>{Number(item?.totalValue || 0).toLocaleString()}</td>
                  <td>
                    <span>
                      <b>ธนาคาร </b>
                      {item.user.bankName}
                    </span>
                    <br />
                    <span>
                      <b>เลขบัญชี </b>
                      {item.user.accountNumber}
                    </span>
                  </td>
                  <td>{item.user.phone ? item.user.phone : '-'}</td>
                  <td>{displayStatusText(item.status)}</td>
                </tr>
              )
            })}
        </tbody>
      </Table>
    )
  }

  return (
    <Card>
      <Card.Header>
        <Card.Title>รางวัล</Card.Title>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col sm={4}>{displayDropdownDate()}</Col>
          <Col sm={8} className="d-flex justify-content-between w-100">
            <Button
              className="ml-2"
              onClick={() => {
                setIsOpenModal(true)
              }}
            >
              อัพเดทสถานะ
            </Button>
            <Button className="ml-2 btn btn-info" onClick={downloadUserPrizesReport}>
              Download รายการทั้งหมดในงวด
            </Button>
          </Col>
        </Row>
        <hr />
        <Row className="d-flex justify-content-between align-items-center mb-4">
          <Col sm={12} md={6} lg={4}>
            <select
              className="form-control"
              style={{ color: '#5d5d5d' }}
              onChange={(value) => {
                setStatus(value.target.value)
              }}
            >
              <option value="all">สถานะโอนเงินทั้งหมด</option>
              {Object.values(PAID_USERPRIZES).map((value, key) => {
                return (
                  <option key={key} value={value.value}>
                    {value.label}
                  </option>
                )
              })}
            </select>
          </Col>
          <Col>
            <input
              className="form-control"
              style={{ color: '#5d5d5d' }}
              type="text"
              placeholder="กรอกรหัสสมาชิก"
              onChange={(e) => {
                setUserId(e.target.value)
              }}
              onKeyDown={async (e) => {
                if (e.key === 'Enter') {
                  e.preventDefault()
                  await fetchAwards(1)
                }
              }}
              defaultValue={userId}
            />
          </Col>
        </Row>
        <Row>{displayTablePrize()}</Row>
        <Pagination
          currentPage={currentPage}
          onPrevPage={() => onChangePage(currentPage - 1)}
          onNextPage={() => onChangePage(currentPage + 1)}
          items={prizes}
          perPage={20}
        />
        <Modal show={showModalPrizes} size="xl" scrollable>
          <Modal.Header className="my-4">
            รางวัลที่ลูกค้าถูก : {user.name} ({user.userId})
            <Button variant="" className="close" onClick={() => setShowModalPrizes(false)}>
              <span>&times;</span>
            </Button>
          </Modal.Header>
          <Modal.Body className="overflow-auto">
            <Table responsive striped bordered>
              <thead className="verticle-middle bg-info text-white">
                <tr>
                  <td>รางวัล</td>
                  <td>งวดที่</td>
                  <td>ชุดที่</td>
                  <td>เบอร์ลอตเตอรี่</td>
                  <td>มูลค่า </td>
                  <td>คำสั่งซื้อ</td>
                </tr>
              </thead>
              <tbody>
                {detailPrizes.map((prize, i) => {
                  const matrixId = prize.lottery.split('-')
                  return (
                    <tr key={i}>
                      <td>{prize.label}</td>
                      <td>{matrixId[1]}</td>
                      <td>{matrixId[2]}</td>
                      <td>{matrixId[3]}</td>
                      <td>{Number(prize?.value || 0).toLocaleString()}</td>
                      <td>
                        <Badge
                          variant="primary light"
                          style={{ cursor: 'pointer' }}
                          onClick={() => {
                            fetchOrderDetail(prize.order)
                          }}
                        >
                          ดูคำสั่งซื้อ
                        </Badge>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </Table>
          </Modal.Body>
        </Modal>
        {showModalOrder && (
          <SelectedOrderModal
            showModalOrder={showModalOrder}
            setShowModalOrder={setShowModalOrder}
            selectedOrder={selectedOrder}
            fetchAwards={fetchAwards}
          />
        )}

        {isOpenModal && (
          <UploadCsvModal roundDate={roundDate} isOpenModal={isOpenModal} setIsOpenModal={setIsOpenModal} />
        )}
      </Card.Body>
    </Card>
  )
}
export default UserPrizes
